import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Smartphone } from "lucide-react";

export default function AppRedirectPage() {
  const [links, setLinks] = useState(null);
  const [platform, setPlatform] = useState("unknown");

  useEffect(() => {
    const ua = navigator.userAgent || "";
    if (/android/i.test(ua)) setPlatform("android");
    else if (/iPad|iPhone|iPod/.test(ua)) setPlatform("ios");
    else setPlatform("desktop");

    api.get("/content/app_links?limit=10").then(res => {
      const items = res.data;
      const linkMap = {};
      items.forEach(item => { linkMap[item.key] = item.url; });
      setLinks(linkMap);
    }).catch(() => setLinks({}));
  }, []);

  useEffect(() => {
    if (!links || platform === "unknown") return;
    if (platform === "android" && links.playstore) {
      window.location.href = links.playstore;
    } else if (platform === "ios" && links.appstore) {
      window.location.href = links.appstore;
    }
  }, [links, platform]);

  if (!links) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <div className="animate-pulse text-slate-400">Redirecting...</div>
      </div>
    );
  }

  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4" data-testid="app-redirect-page">
      <div className="text-center max-w-md">
        <div className="w-20 h-20 bg-jci-blue/10 rounded-2xl flex items-center justify-center mx-auto mb-6">
          <Smartphone className="w-10 h-10 text-jci-blue" />
        </div>
        <h1 className="text-2xl font-bold text-jci-black mb-3">Download Our App</h1>
        <p className="text-slate-500 mb-8">Get the JCI Bangladesh app on your device</p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          {links.playstore && (
            <a
              href={links.playstore}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-jci-black text-white px-6 py-3 rounded-xl font-medium hover:bg-jci-black/90 transition-colors"
              data-testid="playstore-link"
            >
              <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current"><path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 0 1-.61-.92V2.734a1 1 0 0 1 .609-.92zm10.89 10.893l2.302 2.302-10.937 6.333 8.635-8.635zm3.199-3.199l2.807 1.626a1 1 0 0 1 0 1.732l-2.807 1.626L15.206 12l2.492-2.492zM5.864 2.658L16.8 8.99l-2.302 2.302-8.634-8.634z"/></svg>
              Google Play
            </a>
          )}
          {links.appstore && (
            <a
              href={links.appstore}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-jci-blue text-white px-6 py-3 rounded-xl font-medium hover:bg-jci-blue/90 transition-colors"
              data-testid="appstore-link"
            >
              <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current"><path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/></svg>
              App Store
            </a>
          )}
        </div>
      </div>
    </div>
  );
}
